import { Expose } from 'class-transformer';
import { Model } from '../../shared-features/models/model';

export class assignableFleet extends Model {
  @Expose() id: number;
  @Expose() value: string;
  @Expose() isdefault?: boolean;
}
